import React from "react";

export default class Survey extends React.PureComponent {
    scriptId = "smcx-sdk-"; 

    componentDidMount() {
        this.injectScript();
    }

    componentWillUnmount() {
        this.removeScript();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.survey !== this.props.survey) {
            this.removeScript();
            this.injectScript();
        }
    }

    removeScript = () => {
        const {survey} = this.props;

        if(!survey || !survey.hash) return;

        if(window.SMCX && window.SMCX.destroy) {
            window.SMCX.destroy();
            
            const scriptElement = document.getElementById(this.scriptId + survey.hash);

            if (scriptElement) {
                document.head.removeChild(scriptElement);
            }
            
            delete window.SMCX;
        }
    }

    injectScript = () => {
        const {survey} = this.props;
        
        if(!survey || !survey.hash) {
            return;
        }

        // Check if the script is already on the page to avoid re-injecting it
        if (document.getElementById(this.scriptId + survey.hash)) {
            return;
        }
        
        const script = document.createElement('script');
        script.id = this.scriptId + survey.hash; // Unique ID for each survey script
        script.type = 'text/javascript';
        script.async = true;
        script.src = "https://widget.surveymonkey.com/collect/website/js/" + survey.hash + ".js";

        document.head.appendChild(script);
    }

    // This component doesn't render anything to the page itself
    render() {
        return null;
    }
}
